import React, { useState, useEffect } from "react";
import { MDBBtn, MDBRow } from "mdb-react-ui-kit";
import imgg from "../images/register-business/03.png";
import { Link } from "react-router-dom";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";
// config
import configData from "../config/config.json";
// components
import MetaTagsBusinessOwners from "../components/meta-tags-seo/MetaTagsBusinessOwners";
import RegisterBusiness from "./RegisterBusiness";

const RegisterBusinessStep3a = (props) => {
  const [dataCome, setDataCome] = useState(false);
  const [render, setRender] = useState(false);
  const [disable, setDisable] = useState(false);

  const [categories, setCategories] = useState([{}, {}, {}, {}, {}, {}]);
  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    // CatIds: props.location.state,
    Authorization: "Bearer " + getCookie("token"),
  };

  const [active, seActive] = useState([]);

  const handleChange = (event, id) => {
    if (event.target.checked) {
      if (!active.includes(event.target.value)) {
        seActive((active) => [...active, event.target.value]);
      }
    } else {
      seActive(active.filter((item) => item !== event.target.value));
    }
  };

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "register-business-step3",
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    setDataCome(false);
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else {
      // comment for come data from mina -- check api
      // axios
      //   .get(domain + "/api/biz/register/check-complete", {
      //     headers: {
      //       ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
      //       LangId: 1,
      //       OwnerId: OwnerIdCookie,
      //       BizId: getCookie("BizId"),
      //     },
      //   })
      //   .then((response) => {
      //     if (response.data.msg == "not-registered") {
      //       props.history.push({
      //         pathname: "/signup",
      //       });
      //     } else if (response.data.msg == "done") {
      //       if (response.data.IsComplete) {
      //         props.history.push({
      //           pathname: "/business-dashboard",
      //         });
      //       } else if (response.data.RegStep < 3) {
      //         props.history.push({
      //           pathname: `/register-business-step${response.data.RegStep}`,
      //         });
      //       } else {
      // comment for come data from mina -- check api

      // api for meta tags
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      // api to check and get data
      axios
        .get(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/categoryOptions`,
          {
            headers: header,
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            let stepStatus = response.data.data.stepStatus;
            let data = response.data.data;

            // check user is registered or not
            if (!stepStatus.isRegistered) {
              props.history.push({
                pathname: "/signup",
              });
            }
            // check the business steps are completed or not
            else if (stepStatus.isComplete) {
              props.history.push({
                pathname: "/business-dashboard",
              });
            }
            // check the business step number
            else if (stepStatus.regStep < 3) {
              props.history.push({
                pathname: `/register-business-step${stepStatus.regStep}`,
              });
            } else {
              if (JSON.parse(localStorage.getItem("step3-back-data"))) {
                // set data from local storage to states
                let dataLocal = JSON.parse(
                  localStorage.getItem("step3-back-data")
                );
                seActive(dataLocal);
              } else {
                // set data from api to states
                for (let index = 0; index < data.options.length; index++) {
                  const element = data.options[index];
                  if (element.isSelected) {
                    if (!active.includes(element.cotId)) {
                      const elementb = element.cotId + "";
                      seActive((active) => [...active, elementb]);
                    }
                  }
                }
              }
              setCategories(data.options);
              setDataCome(true);
            }
          } else {
            setCategories([]);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      // comment for come data from mina -- load step3 api
      // axios
      //   .get(domain + "/api/biz/register/load-step3", {
      //     headers: {
      //       ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
      //       LangId: 1,
      //       BizId: getCookie("BizId"),
      //       CatIds: JSON.parse(localStorage.getItem("CatId")),
      //     },
      //   })
      //   .then((response) => {
      //     setDataCome(true);

      //     if (response.data.msg == "done") {
      //       setCategories(response.data.Options);
      //       for (let index = 0; index < response.data.Options.length; index++) {
      //         const element = response.data.Options[index];
      //         if (element.IsSelected) {
      //           if (!active.includes(element.COTId)) {
      //             const elementb = element.COTId + "";

      //             seActive((active) => [...active, elementb]);
      //           }
      //         }
      //       }
      //     } else {
      //       setCategories([]);
      //     }
      //   })
      //   .catch((error) => {
      //     // alert(error);
      //   });
      // comment for come data from mina -- load step3 api

      setRender(true);
      // comment for come data from mina -- check api
      // }
      //   }
      // })
      // .catch((error) => {
      //   // alert(error);
      // });
    }
  }, []);

  const submitHandler = (event) => {
    event.preventDefault();
    setDisable(true);

    const ownerId = getCookie("OwnerId");
    var amenities = "";
    for (let index = 0; index < active.length; index++) {
      const element = active[index];
      if (element) {
        if (index == 0) {
          amenities = element;
        } else {
          amenities = amenities + "," + element;
        }
      }
    }

    const dataPost = {
      amenities,
      bId: getCookie("BizId"),
    };

    axios
      .post(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/categoryOptions`,
        dataPost,
        {
          headers: header,
        }
      )
      .then((response) => {
        setDisable(false);

        if (response.data.isSuccess) {
          // success
          localStorage.removeItem("step3-back-data"); // remove data of step3 saved by back button

          props.history.push({
            pathname: "/register-business-step4",
          });
        }
      })
      .catch((error) => {
        // alert(error);
      });
  };

  const backHandler = () => {
    const data = active;
    localStorage.setItem("step3-back-data", JSON.stringify(data)); //set step3 loocal storage

    props.history.push({
      pathname: "/register-business-step2",
    });
  };

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <>
      {render ? (
        <>
          {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

          <RegisterBusiness />
          <div>
            <MDBRow className="mx-0">
              <div className="col-12 col-md-8 register-business-padd">
                <div className="register-steps-right">
                  <h1 className="rb-step3a-tit">
                    کسب‌وکار شما کدام امکانات را دارد؟
                  </h1>

                  <div dir="rtl" className="rbtn-s3a row mb-n2 mb-md-0">
                    {categories.map((item) =>
                      dataCome ? (
                        <div className="col-12 col-md-6" key={item.cotId}>
                          <label className="container-s2" id={item.cotId}>
                            <input
                              onChange={(event) =>
                                handleChange(event, item.cotId)
                              }
                              type="checkbox"
                              id={item.cotId}
                              name={item.cotId}
                              value={item.cotId}
                              defaultChecked={
                                active.includes(`${item.cotId}`) ? true : false
                              }
                            />

                            <span className="checkmark-s2"></span>
                            <span>{item.title}</span>
                          </label>
                        </div>
                      ) : (
                        <div className="col-12 col-md-6" key={item.cotId}>
                          <div className="d-flex justify-content-right Skeleton-me-res  mt-1 mb-2 me-1">
                            <Skeleton
                              className=""
                              variant="rectangular"
                              width={16}
                              height={16}
                              animation="wave"
                              rounded
                            />
                            <Skeleton
                              className="w-80 me-3"
                              variant="text"
                              sx={{ fontSize: "0.5rem" }}
                              animation="wave"
                            />
                          </div>
                        </div>
                      )
                    )}
                  </div>

                  <div className=" mt-0">
                    {dataCome ? (
                      <div className="rb-steps-btns">
                        <Link
                          // to="/register-business-step2"
                          className="rb-steps-btn1 hov-shadow"
                          onClick={backHandler}
                        >
                          مرحله قبلی
                        </Link>
                        <MDBBtn
                          disabled={disable}
                          className="rb-steps-btn2 hov-shadow"
                          onClick={submitHandler}
                        >
                          مرحله بعدی
                        </MDBBtn>
                      </div>
                    ) : (
                      <div className="rb-steps-btns">
                        <Skeleton
                          className="rb-steps-btn2 h-Skeleton-39"
                          variant="rectangular"
                          width={123}
                          height={39}
                          animation="wave"
                        />
                        <Skeleton
                          className="rb-steps-btn2 h-Skeleton-39"
                          variant="rectangular"
                          width={123}
                          height={39}
                          animation="wave"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 px-0 text-center d-md-block d-none">
                <img
                  className="register-business-img"
                  src={imgg}
                  alt="register business"
                />
              </div>
            </MDBRow>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default RegisterBusinessStep3a;
